import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/glossary';
import { ResultState } from '@rootCommon/types/common';
import {
  Cidr,
  Country,
  FacilityType,
  IpWhitelistMode,
  JobTitle,
  Language,
  NotificationRuleGlossary,
  Prefix,
  Suffix,
  Timezone,
} from '@rootCommon/types/glossary';
import { GlossaryPayload as gp } from '@rootCommon/constants/glossaries';

type Action = ActionType<typeof actions>;

export const glossaries = [
  gp.COUNTRIES,
  gp.NOTIFICATION_RULES,
  gp.LANGUAGES,
  gp.TIMEZONES,
  gp.FACILITY_TYPES,
  gp.PREFIXES,
  gp.SUFFIXES,
  gp.JOB_TITLES,
  gp.IP_WHITELIST_MODES,
  gp.CIDRS,
];

export type GlossaryData = {
  [gp.COUNTRIES]: Country[] | null;
  [gp.NOTIFICATION_RULES]: NotificationRuleGlossary[] | null;
  [gp.LANGUAGES]: Language[] | null;
  [gp.TIMEZONES]: Timezone[] | null;
  [gp.FACILITY_TYPES]: FacilityType[] | null;
  [gp.PREFIXES]: Prefix[] | null;
  [gp.SUFFIXES]: Suffix[] | null;
  [gp.JOB_TITLES]: JobTitle[] | null;
  [gp.IP_WHITELIST_MODES]: IpWhitelistMode[] | null;
  [gp.CIDRS]: Cidr[] | null;
};

const initialValues: GlossaryData = Object.assign({}, ...glossaries.map((item) => ({ [item]: null })));

export type GlossaryDataState = ResultState<GlossaryData>;

const initState: GlossaryDataState = {
  data: initialValues,
  loading: false,
  error: null,
};

const glossaryReducer = (state = initState, action: Action): GlossaryDataState => {
  switch (action.type) {
    case getType(actions.fetchGlossaryData.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchGlossaryData.success):
      return { ...state, loading: false, data: { ...state.data, [action.payload.type]: action.payload.data } };
    case getType(actions.fetchGlossaryData.failure):
      return { ...state, loading: false, error: action.payload };

    case getType(actions.fetchGlossariesData.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchGlossariesData.success):
      return {
        ...state,
        loading: false,
        data: { ...state.data, ...action.payload },
      };
    case getType(actions.fetchGlossariesData.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default glossaryReducer;
